const rmsRoutes = [
	{
		path: '/rms',
		name: 'rms-default',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'Risk Management Tasks',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app', 'use.apps.rms.app'],
		},
	},

	{
		path: '/rms/tasks',
		name: 'rms-tasks',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'Risk Management Tasks',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app', 'use.apps.rms.app'],
		},
	},

	{
		path: '/rms/tasks/:uuid',
		name: 'rms-tasks-resource',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'Risk Management Tasks',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app', 'use.apps.rms.app'],
		},
	},

	{
		path: '/rms/registers',
		name: 'rms-registers',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'registers' },
		meta: {
			name: 'Risk Management Registers',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app', 'use.apps.rms.app'],
		},
	},

	{
		path: '/rms/heatmap',
		name: 'rms-heatmap',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'heatmap' },
		meta: {
			name: 'Risk Management Heatmap',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app', 'use.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin',
		name: 'rms-admin',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'dashboard' },
		meta: {
			name: 'Risk Management Admin',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin/cycles',
		name: 'rms-admin-cycles',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'cycles_list' },
		meta: {
			name: 'Risk Management Cycles',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin/risk-runs',
		name: 'rms-admin-risk-runs',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'risk_runs_list' },
		meta: {
			name: 'Risk Management Risk Runs',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin/measures',
		name: 'rms-admin-measures',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'risk_measures_list' },
		meta: {
			name: 'Risk Management Measures',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin/users',
		name: 'rms-admin-users',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'users' },
		meta: {
			name: 'Risk Management Users',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},

	{
		path: '/rms/admin/entities',
		name: 'rms-admin-entities',
		component: () => import('@/apps/rms/Home.vue'),
		props: { view: 'admin', scene: 'entities' },
		meta: {
			name: 'Risk Management Entities',
			permissions: ['admin.apps.rms.app', 'manage.apps.rms.app'],
		},
	},
]

export default rmsRoutes
